import TrashController from './Trash.controller'
import TrashView from './Trash.view.vue'

export default TrashController(TrashView)
